"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _utils = require("../../utils");
var _index = _interopRequireDefault(require("../../renderings/Accordion/index"));
var _index2 = _interopRequireDefault(require("../../renderings/CallOutCard/index"));
var _index3 = _interopRequireDefault(require("../../renderings/CardLinkList/index"));
var _index4 = _interopRequireDefault(require("../../renderings/ContactCard/index"));
var _index5 = _interopRequireDefault(require("../../renderings/HorizontalCard/index"));
var _index6 = _interopRequireDefault(require("../../renderings/LoginCard/index"));
var _index7 = _interopRequireDefault(require("../../renderings/MediaCard/index"));
var _index8 = _interopRequireDefault(require("../../renderings/VerticalCard/index"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A list of cards
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A React Element
 */
function SideBarList(props) {
  if (!props.rendering.fields) return null;
  var cardProps = {
    rendering: {
      fields: ''
    },
    params: {
      ImgHeight: ''
    }
  };
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.id),
    className: 'app-container'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'row card-list vertical blog-sidebar'
  }, extractedFields.CardList.map(comp => {
    cardProps = {
      rendering: {
        fields: comp.fields
      },
      params: {
        ImgHeight: 0
      }
    };
    switch (comp.fields.CardType.value) {
      case 'horizontalWithLinks':
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "col",
          key: comp.id
        }, /*#__PURE__*/_react.default.createElement(_index3.default, cardProps));
      case 'media':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          key: comp.id
        }, /*#__PURE__*/_react.default.createElement(_index7.default, cardProps));
      case 'vertical':
        cardProps.params.ImgHeight = extractedFields.VerticalCardImgHeight.value;
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          xs: 12,
          md: 12,
          key: comp.id
        }, /*#__PURE__*/_react.default.createElement(_index8.default, cardProps));
      case 'login':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          xs: 12,
          md: 12,
          key: comp.id
        }, /*#__PURE__*/_react.default.createElement(_index6.default, cardProps));
      case 'contact':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          xs: 12,
          md: 12,
          key: comp.id
        }, /*#__PURE__*/_react.default.createElement(_index4.default, cardProps));
      case 'callout':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          xs: 12,
          md: 12,
          key: comp.id
        }, /*#__PURE__*/_react.default.createElement(_index2.default, cardProps));
      case 'accordion':
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          xs: 12,
          md: 12,
          key: comp.id
        }, /*#__PURE__*/_react.default.createElement(_index.default, cardProps));
      default:
        cardProps = {
          rendering: {
            fields: comp.fields
          },
          imageColSize: 'col-md-5',
          bodyColSize: 'col-md-7',
          params: props.params
        };
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          sm: 12,
          md: 12,
          key: comp.id
        }, /*#__PURE__*/_react.default.createElement(_index5.default, cardProps));
    }
  })));
}
var _default = exports.default = SideBarList;